module.exports = __webpack_public_path__ + "static/media/wa.e2e6a0ec.png";